<script setup>
import VueDatePicker from "@vuepic/vue-datepicker";
import {computed} from "vue";
import {getDateLocale} from "@/utils/locale.js";

const props = defineProps({
    required: {
        type: Boolean,
        default: false
    },
    placeholder: {
        type: String,
    },
    format: {
        type: String,
        default: 'dd-MM-yyyy'
    },
    enableTimePicker: {
        type: Boolean,
        default: false
    },
    id: {
        type: String,
    },
    minDate: {}
})

const model = defineModel();

const isDarkMode = computed(() =>
    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
)
</script>

<template>
    <VueDatePicker
        :required="required"
        :id="id"
        v-model="model"
        :minDate="minDate"
        :placeholder="placeholder"
        :auto-apply="true"
        :dark="isDarkMode"
        :ui="{ input: 'input' }"
        :enable-time-picker="enableTimePicker"
        :cancel-text="$t('actions.cancel')"
        :select-text="$t('actions.select')"
        :format-locale="getDateLocale($i18n.locale)"
        :format="format"/>
</template>
